const STORAGE_KEY = 'commandlinc.avatarOverlay.v2';
const DOCKS = Object.freeze(['bottom-right', 'bottom-left', 'top-right', 'top-left']);

const emptyPreferences = () => ({
  hidden: {},
  minimized: {},
  muted: {},
  docks: {},
  positions: {},
});

const normalizePosition = (position) => ({
  x: Number.isFinite(Number(position?.x)) ? Number(position.x) : 0,
  y: Number.isFinite(Number(position?.y)) ? Number(position.y) : 0,
});

export function loadAvatarPreferences(storage = globalThis?.localStorage) {
  if (!storage) return emptyPreferences();
  try {
    const parsed = JSON.parse(storage.getItem(STORAGE_KEY) || '{}');
    const positions = Object.fromEntries(
      Object.entries(parsed.positions || {}).map(([id, position]) => [id, normalizePosition(position)]),
    );
    return { ...emptyPreferences(), ...parsed, positions };
  } catch {
    return emptyPreferences();
  }
}

export function saveAvatarPreferences(preferences, storage = globalThis?.localStorage) {
  if (!storage) return;
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(preferences));
  } catch {
    // Storage can be disabled. The overlay remains functional for this session.
  }
}

export function nextDock(currentDock) {
  const index = DOCKS.indexOf(currentDock);
  return DOCKS[(index + 1 + DOCKS.length) % DOCKS.length];
}

export { DOCKS, STORAGE_KEY };
